



























import { computed, defineComponent, getCurrentInstance, ref, nextTick } from '@vue/composition-api';
import { StepItemProps } from 'tdesign-vue';
import StepForm1 from '@/renderer/views/desktop/FileManagement/Workbench/components/Welcome/components/Step/StepForm1.vue';
import StepForm2 from '@/renderer/views/desktop/FileManagement/Workbench/components/Welcome/components/Step/StepForm2.vue';
import StepForm3 from '@/renderer/views/desktop/FileManagement/Workbench/components/Welcome/components/Step/StepForm3.vue';
import i18n, { i18n_t } from '@/locales/i18n';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import ipc from '@/renderer/scripts/utils/ipc';
import guideHandler from '@/renderer/views/desktop/FileManagement/Workbench/composition/guideHandler';
import { startGuideSteps } from '@/renderer/scripts/utils/GuideHelper';
export default defineComponent({
  name: 'WelcomeStep',
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  components: {
    StepForm1,
    StepForm2,
    StepForm3,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const stepNumber = ref<number>(0);
    const { methods: guideMethods } = guideHandler();
    // 是否是最后一步
    const lastStep = computed<boolean>(() => {
      if (stepNumber.value === 2) {
        context.emit('lastStep', true);
      } else {
        context.emit('lastStep', false);
      }
      return stepNumber.value === 2;
    });
    const firstStep = computed<boolean>(() => stepNumber.value === 0);
    const steps = ref<Array<StepItemProps>>([
      {
        title: i18n_t('定制企业形象'),
        value: 0,
      },
      {
        title: i18n_t('行业身份确认'),
        value: 1,
      },
      {
        title: i18n_t('组建管理团队'),
        value: 2,
      },
    ]);
    const methods = {
      goManage() {
        const { didAdmin } = vm.$store.getters.noviceGuidance;
        innerShow.value = false;
        reporter.report('manager_new_guide_success', {
          success_count_type: 'step_three_control_center',
        });
        nextTick(() => {
          const admin = [
            {
              id: 'spaceStatistics',
              title: i18n_t('这里进入/退出管理中心'),
              context: i18n_t('统一管理企业员工，企业资产及企业网盘空间。'),
              type: 'goAdmin',
              position: 'right-bottom',
            },
          ];
          if (!didAdmin?.didOpenManage) {
            startGuideSteps(admin);
            guideMethods.goAdminGuide('manage');
            ipc.emit(ipc.RENDERER_EVENTS_MAP.START_GUIDE);
          }
        });
        innerShow.value = false;
      },
      submitForm1() {
        const stepForm1 = vm.$refs.stepForm1 as any;
        stepForm1.sub();
      },
      submitForm2() {
        const stepForm2 = vm.$refs.stepForm2 as any;
        stepForm2.sub();
      },
      submitForm3() {
        const stepForm3 = vm.$refs.stepForm3 as any;
        stepForm3.sub();
      },
      init() {
        stepNumber.value = 0;
      },
      async nextStep() {
        switch (stepNumber.value) {
          case 0:
            methods.submitForm1();
            break;
          case 1:
            methods.submitForm2();
            break;
          case 2:
            methods.submitForm3();
            break;
          default:
            break;
        }
        stepNumber.value++;
      },
    };
    return {
      lastStep,
      firstStep,
      stepNumber,
      steps,
      ConstantConfig,
      ...methods,
    };
  },
});
